/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    export class SettingsFleetUploadDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            '$interval',
            '$timeout',
            'SettingsFleetUploadService',
            'DealerwareFleetModel',
            '$mobilityCompanyAuthentication',
            '$dealerwareNotification',
            '$dealerwareLoading'
        ];

        private static get UPLOAD_STATUSES () : any {
            return {
                NONE:           'None',
                CHECKING:       'Checking...',
                IN_PROGRESS:    'Processing vehicles...',
                FINISHED:       'Vehicles Processed',
                TIMEOUT:        'Vehicle Processing Timeout',
                ERROR_UPLOAD:   'Vehicles Upload Error',
                ERROR_STATUS:   'Vehicle Processing Error'
            }
        }

        private fileToUpload                : any;
        private uploadStatus                : string = 'NONE';
        private currentUploadData           : any = { };

        private checkUploadStatusInterval   : ng.IPromise<{}>;
        private uploadProgressToast         : any;

        // Poor man's debounce.
        //
        public uploadStatusInProgress       : boolean = false;

        private onSuccess                   : any;
        private showInstructions            : number = -1;


        constructor(
            private $scope                       : any,
            private $interval                    : any,
            private $timeout                     : any,
            private SettingsFleetUploadService   : any,
            private DealerwareFleetModel         : any,
            private $auth                        : any,
            private $dealerwareNotification      : any,
            private $dealerwareLoading           : any
        ) {

            var that = this;

            this.initializeCurrentUploadData();

            // Dragging a file to the target zone, or browsing for it, fires off this watcher
            // and the file gets POSTed to the backend.
            //
            var cancelUploadFileWatcher = this.$scope.$watch(
                ( ) => {
                    return that.fileToUpload;
                },
                ( file: any ) => {

                    if (file !== undefined) {
                        that.uploadFile (file);
                    }
                }
            );

            this.$scope.$on('$destroy', function() {
                cancelUploadFileWatcher();
                that.stopCheckForUpload();
            });

            this.startCheckForUpload();
        }

        private get uploadStatuses () : any {
            return SettingsFleetUploadDirectiveController.UPLOAD_STATUSES;
        }

        private initializeCurrentUploadData () : void {

            this.currentUploadData = {
                fileName    : null,
                createdAt   : null,

                processedRecords: ( ) => {

                    return this.currentUploadData.stats.categories.reduce( ( processedCount: number, category: any ) => {
                        return processedCount + category.itemCount;
                    }, 0);
                },

                recordCounts: ( type: string ) =>  {

                    return this.currentUploadData && this.currentUploadData.stats &&
                        (type === 'total' ? this.currentUploadData.stats.total.itemCount :
                                this.currentUploadData.stats.categories.find( ( category: any ) => {
                                    return category.key === type;
                                }).itemCount
                        );
                },

                stats  : {
                    total: {
                        label: 'Total',
                        itemCount: null
                    },
                    categories: [
                        { key: 'success', label: 'Successes', itemCount: null },
                        { key: 'duplicate', label: 'Duplicates', itemCount: null },
                        { key: 'failure', label: 'Failures', itemCount: null },
                    ]
                }
            };
        }

        private statusText () : string {
            return this.uploadStatus === null ? '' : this.uploadStatuses[this.uploadStatus];
        }

        private get currentUpload () : string {

            if (! this.uploadStatus) {
                return '';
            }

            if (this.uploadStatus !== 'FINISHED') {
                return this.uploadStatuses[this.uploadStatus];
            }
            else {
                return this.currentUploadData.recordCounts('success') + ' vehicle'
                    + (this.currentUploadData.recordCounts('success') === 1 ? '' : 's');
            }
        }

        private stopCheckForUpload () : void {

            var that = this;

            if (this.checkUploadStatusInterval) {
                this.$interval.cancel(this.checkUploadStatusInterval);
            }

            if (this.uploadProgressToast) {
                this.$timeout( ( ) => {
                    that.uploadProgressToast.$mdToast.cancel();
                    that.uploadProgressToast = null;
                }, 6000);
            }
        }

        private showUploadProgress () : void {

            this.initializeCurrentUploadData();

            this.uploadProgressToast = this.$dealerwareNotification;
            this.uploadProgressToast.fullToast ({
                templateUrl     : '/components/progress-toast/progress-toast-directive.html',
                hideDelay       : 0,
                scope           : angular.extend(this.$scope, {
                    progressData        : this.currentUploadData,
                    statusText          : ( ) => this.statusText.call(this),
                    showTotalItemCount  : true
                }),
                preserveScope   : true
            });
        }

        private startCheckForUpload ( fileJustUploaded? : boolean ) : void {

            var that = this;

            var lastProcessed   : number = 0;
            var checkCount      : number = 1;

            // Jumped from (successful) file upload, so start progress right away.
            //
            if (fileJustUploaded) {
                that.showUploadProgress();
            }
            // Need to check and see if we've had an upload in the past.
            //
            else {
                this.uploadStatus = 'CHECKING';
            }

            var interval = this.$interval(

                ( ) => {

                    if (this.uploadStatusInProgress) {
                        return;
                    }

                    this.uploadStatusInProgress = true;

                    that.DealerwareFleetModel.getUploadStatus ({
                        params: {
                            location_id : that.$auth.location.id
                        },
                        promise: true
                    })
                    .then( ( response : any ) => {

                        that.currentUploadData.fileName                     = response.data.file_name;
                        that.currentUploadData.createdAt                    = response.data.created_at;
                        that.currentUploadData.stats.total.itemCount        = response.data.total;
                        that.currentUploadData.stats.categories[0].itemCount= response.data.successes;
                        that.currentUploadData.stats.categories[1].itemCount= response.data.existing;
                        that.currentUploadData.stats.categories[2].itemCount= response.data.failures;

                        // None processed means no fleet file uploaded.
                        //
                        if (response.data.processed === 0) {
                            that.uploadStatus = 'NONE';
                            that.stopCheckForUpload();
                            return;
                        }

                        // If the number processed doesn't change for awhile, make the assumption tha
                        // upload processing has stalled or crashed without an error.
                        //
                        if (response.data.processed === lastProcessed && checkCount === 5000) {
                            that.uploadStatus = 'TIMEOUT';
                            that.stopCheckForUpload();
                            return;
                        }

                        // Upload finished, either during this page visit or earlier.
                        //
                        if (response.data.processed === response.data.total) {
                            that.uploadStatus = 'FINISHED';
                            that.stopCheckForUpload();
                        }
                        // Checking to see if we have an active upload, which we may or may not.
                        // If the counts aren't finished, and we haven't just finished a file upload,
                        // then kick off the progress toast.
                        //
                        else if (that.uploadStatus !== 'IN_PROGRESS') {
                            that.uploadStatus = 'IN_PROGRESS';
                            that.showUploadProgress();
                        }

                        checkCount++;
                        lastProcessed = response.data.processed;
                    })
                    .catch( ( ) => {
                        that.uploadStatus = 'ERROR_STATUS';
                        that.stopCheckForUpload();
                    })
                    .finally( ( ) => {
                        this.uploadStatusInProgress = false;
                    });
                }, 1500
            );

            this.checkUploadStatusInterval = interval;
        }

        private uploadFile (chosenFile: any) : void {

            var that = this;

            var wrongFileTypeMessage = 'Error, there was a problem with your file.  Fleet Upload supports .csv files; '
                + 'perhaps your file is of the wrong type?';

            if (chosenFile === null) {
                that.$dealerwareNotification.error(wrongFileTypeMessage);
                return;
            }

            var loader = this.$dealerwareLoading.show ('Uploading...');

            this.SettingsFleetUploadService.uploadFile (chosenFile, this.$auth.location.id)
                .then( ( ) => {

                    loader.close();
                    that.$dealerwareNotification.toast ('Upload succeeded')
                        .then( ( ) => {

                            that.uploadStatus = 'IN_PROGRESS';
                            that.currentUploadData.fileName = chosenFile.name;
                            that.startCheckForUpload (true);

                            // e.g. (but really i.e.) for the registration wizard.
                            //
                            if (that.onSuccess) {
                                that.onSuccess();
                            }
                        });
                })
                .catch( ( errorResponse: any ) => {
                    loader.close();
                    that.$dealerwareNotification.apiError(errorResponse, wrongFileTypeMessage);
                    that.uploadStatus = 'ERROR_UPLOAD';
                });
        }
    }

    getDealerwareWebComponentsModule().controller(
        'SettingsFleetUploadDirectiveController',
        SettingsFleetUploadDirectiveController
    );


    export class SettingsFleetUploadDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'SettingsFleetUploadDirectiveController';
        public controllerAs     : string    =   'settingsFleetUploadController';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/settings/fleet/fleet-upload-directive.html';
        public scope            : Object    =   { onSuccess: '&?' };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareSettingsFleetUpload',
        ( ) => new SettingsFleetUploadDirective()
    );


    export class SettingsFleetUploadService {

        private utils: any;

        constructor(
            private DataUtils            : any,
            private $q                   : any,
            private DealerwareFleetModel : any,
            private Upload               : any
        ) {

            this.utils = this.DataUtils.getInstance();
        }

        private uploadFile (chosenFile: any, locationId: number) : ng.IPromise<{}> {

            var defer = this.$q.defer();

            chosenFile.upload = this.Upload.upload({
                url : this.utils.bindEndpoint (
                    this.DealerwareFleetModel.uploadFleet.endpoint.replace(
                        /:location_id/, locationId
                    )
                ),
                data : { file: chosenFile }
            })
            .then(
                ( response: any ) => {
                    defer.resolve (response.data);
                },

                ( errorResponse: any ) => {
                    defer.reject (errorResponse);
                }
            );

            return defer.promise;
        }
    }

    getDealerwareWebComponentsModule().factory('SettingsFleetUploadService', (
        DataUtils               : any,
        $q                      : any,
        DealerwareFleetModel    : any,
        Upload                  : any
    ) => new SettingsFleetUploadService (DataUtils, $q, DealerwareFleetModel, Upload));

}
